import BannerSlider from "./BannerSlider";

export default BannerSlider